import { z } from "zod";
import { ComponentSelectionSchema } from "./component-selection.js";
import { ComponentRoleSchema } from "./component-role.js";
import { RecipeDecisionLogV1Schema } from "./recipe-decision-log.js";
import { SurfaceTypeSchema } from "./surface-grammar.js";
export const IntentProfileSchema = z
    .object({
    vertical: z.string().min(1),
    servicesCount: z.number().int().min(0),
    serviceAreasCount: z.number().int().min(0),
    emergencyIntent: z.boolean().default(false),
    commercialIntent: z.boolean().default(false),
    residentialIntent: z.boolean().default(false),
    ctaGoal: z.enum(["phone", "booking", "quote", "contact"]).default("contact"),
    hasProof: z.boolean(),
    hasAssets: z.boolean(),
    hasFaqs: z.boolean(),
    hasOffer: z.boolean(),
    lensId: z.string().min(1).optional(),
    strategyId: z.string().min(1).optional(),
    surfaceType: SurfaceTypeSchema.default("marketingSite"),
    referenceId: z.string().min(1).optional(),
})
    .strict();
export const FallbackDecisionSchema = z
    .object({
    decisionId: z.string().min(1),
    from: z.string().min(1),
    to: z.string().min(1),
    reasonCode: z.string().min(1),
    clientSafeSummary: z.string().min(1),
})
    .strict();
export const IntentPlannerOutputV1Schema = z
    .object({
    schemaVersion: z.literal("intent-planner-output.v1.0"),
    plannerVersion: z.string().min(1),
    intentProfile: IntentProfileSchema,
    lensId: z.string().min(1).optional(),
    strategyId: z.string().min(1).optional(),
    surfaceType: SurfaceTypeSchema.default("marketingSite"),
    referenceId: z.string().min(1).optional(),
    recipeId: z.string().min(1).optional(),
    sectionOrder: z.array(ComponentRoleSchema),
    componentSelections: z.array(ComponentSelectionSchema),
    fallbackDecisions: z.array(FallbackDecisionSchema),
    ctaStrategy: z.string().min(1),
    proofStrategy: z.string().min(1),
    recipeDecisionLog: RecipeDecisionLogV1Schema,
})
    .strict();
//# sourceMappingURL=intent-planner.js.map